import { ReactComponent as Plivo } from '@shared/assets/icons/ic-plivo.svg'
import { cn } from 'lib/utils'
import { LoaderCircle } from 'lucide-react'

interface LoaderProps {
  text?: string
  variant?: 'default' | 'inline' | 'circle'
}
export const Loader: React.FC<LoaderProps> = ({ text, variant = 'default' }) => (
  <div
    className={cn(
      'flex items-center justify-center bg-background/90 text-secondary gap-1',
      (variant === 'default' || variant === 'circle') && 'absolute inset-0 flex-col',
      variant === 'inline' && 'flex-row',
    )}
  >
    {variant === 'circle' || variant === 'inline' ? (
      <LoaderCircle className="animate-spin" size={variant === 'inline' ? 16 : 28} />
    ) : (
      <>
        <img
          src="/Buddy_running.webp"
          alt="Loading"
          className="h-28 w-auto pointer-events-none select-none animate-in fade-in duration-300 dark:hidden"
        />
        <Plivo className="hidden dark:block size-10 opacity-90 invert animate-in fade-in duration-300" />
      </>
    )}
    {text && <span className="text-p-400 text-secondary animate-in fade-in">{text}</span>}
  </div>
)
